import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgWarningIcon = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00003 1.54712L15.2117 13.6931H0.78833L8.00003 1.54712ZM2.54507 12.6931H13.455L8.00003 3.50583L2.54507 12.6931ZM8.50003 6.35981V10.0265H7.50003V6.35981H8.50003ZM8.50003 10.6865V11.6931H7.50003V10.6865H8.50003Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgWarningIcon);
export default ForwardRef;
